import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCms } from "../context/CmsContext";
import SectionHead from "../components/SectionHead";
import "../partyBossTheme.css";

const MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.23390944607!2d78.3536850768564!3d17.49634405690453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93006b40a15b%3A0x423e4606cc572845!2sParty%20Boss%20-%20Private%20Theatres!5e0!3m2!1sen!2sin!4v1731037025349!5m2!1sen!2sin";

const Contact = () => {
  const { cms } = useCms();
  const h = cms.home;
  const navigate = useNavigate();
  const f = h.footer || {};

  const waLink = useMemo(
    () => (text) =>
      `https://wa.me/${h.whatsappNumber}?text=${encodeURIComponent(text)}`,
    [h.whatsappNumber]
  );

  useEffect(() => {
    document.body.classList.add("party-boss-home");
    const revealOnScroll = () => {
      document.querySelectorAll(".party-boss-reveal").forEach((item) => {
        const top = item.getBoundingClientRect().top;
        if (top < window.innerHeight - 90) item.classList.add("active");
      });
    };
    revealOnScroll();
    window.addEventListener("scroll", revealOnScroll, { passive: true });
    return () => {
      document.body.classList.remove("party-boss-home");
      window.removeEventListener("scroll", revealOnScroll);
    };
  }, []);

  return (
    <div className="party-boss-page w-full overflow-x-clip bg-[#05020a] text-white selection:bg-pink-500/40">
      <div className="party-boss-bg relative z-10 pb-24">
        <SectionHead
          id="contact"
          className="scroll-mt-28"
          eyebrow="Get in touch"
          title="Contact Party Boss"
          text={
            f.body ||
            "Reach us for bookings, venue questions, and celebration planning in Hyderabad."
          }
        />

        <section className="mx-[5%] grid gap-10 rounded-[38px] border border-white/15 bg-white/5 p-8 lg:mx-[8%] lg:grid-cols-[1fr_1.1fr] lg:p-12">
          <div className="party-boss-reveal flex flex-col justify-center">
            <h2 className="mb-4 text-2xl font-black md:text-3xl">{f.title}</h2>
            <div className="space-y-3 text-base leading-8 text-[#c9c1d9]">
              {(f.contactLines || []).map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
            <p className="mt-2 text-sm text-white/50">
              Email:{" "}
              <a
                href="mailto:info@partyboss.in"
                className="text-[#ffd166] underline-offset-2 hover:underline"
              >
                info@partyboss.in
              </a>
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => navigate("/booknow")}
                className="rounded-full bg-gradient-to-r from-pink-500 to-violet-600 px-6 py-3 text-sm font-black text-white md:text-[15px]"
              >
                {f.bookLabel || "Book now"}
              </button>
              <a
                href={waLink("Hi Party Boss")}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center rounded-full border border-white/30 bg-white/10 px-5 py-3 text-sm font-black text-white transition hover:bg-white/20 md:text-[15px]"
              >
                {f.whatsappLabel || "WhatsApp"}
              </a>
            </div>
          </div>
          <div className="party-boss-reveal min-h-[280px] overflow-hidden rounded-[28px] border border-white/15 shadow-2xl lg:min-h-[400px]">
            <iframe
              title="Party Boss location"
              src={MAP_EMBED}
              width="600"
              height="450"
              className="h-full min-h-[280px] w-full border-0 lg:min-h-[400px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
